export const DEPOSIT_STATUS_ENUM = {
    ISSUED: { label: 'Émis', value: "ISSUED" },
    SENT: { label: 'Envoyé', value: "SENT" },
    PAID: { label: 'Payé', value: "PAID" },
    ABORTED: { label: 'Annulé', value: "ABORTED" }
}

// Ordre d'affichage (Émis → Envoyé → Payé)
export const DEPOSIT_STATUS_PIPELINE = [
    DEPOSIT_STATUS_ENUM.ISSUED,
    DEPOSIT_STATUS_ENUM.SENT,
    DEPOSIT_STATUS_ENUM.PAID,
];

export const TERMINAL_DEPOSIT_STATUSES = [DEPOSIT_STATUS_ENUM.ABORTED];

// Statut de l'acompte : les acomptes créés avant la gestion du statut sont considérés comme émis
export function getDepositStatus(business) {
    if (!business || !business.depositNumber) return undefined;
    return business.depositStatus || DEPOSIT_STATUS_ENUM.ISSUED.value;
}

// Un acompte annulé n'est ni comptabilisé ni déduit de la facture
export function isDepositAborted(business) {
    return getDepositStatus(business) === DEPOSIT_STATUS_ENUM.ABORTED.value;
}

// Mêmes règles que possibleDepositStatus côté ms-business (Annulé n'est jamais proposé : il est automatique)
export function possibleDepositStatusSelect(business) {
    const values = [];
    const status = getDepositStatus(business);

    // SENT
    if (status === DEPOSIT_STATUS_ENUM.ISSUED.value) {
        values.push(DEPOSIT_STATUS_ENUM.SENT);
    }

    // PAID
    if (status === DEPOSIT_STATUS_ENUM.ISSUED.value || status === DEPOSIT_STATUS_ENUM.SENT.value) {
        values.push(DEPOSIT_STATUS_ENUM.PAID);
    }

    // ABORTED : jamais manuel, l'acompte est annulé automatiquement avec la facture (ms-business)

    // Current status
    values.push(DEPOSIT_STATUS_ENUM[status]);

    return values;
}
